import React, { useContext } from "react";
import { motion as m } from "framer-motion";

import Bookmark from "../components/Bookmark";
import MyPic from "../assets/me.png";

import { CursorContext } from "../context/CursorContext";
import { animationVariants } from "../config/animationConstants";

const About = () => {
  const { mouseEnterHandler, mouseLeaverHandler } = useContext(CursorContext);

  return (
    <section className='section'>
      <Bookmark />
      <div
        className='
          col-span-10
          flex flex-col lg:flex-row
          items-center justify-center
          gap-10
          p-4 lg:p-6
        '
      >
        <m.div
          initial='hidden'
          animate='visible'
          variants={animationVariants}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaverHandler}
          className='w-full lg:w-2/3 text-justify p-2 md:p-4'
        >
          <h1 className='text-2xl lg:text-4xl'>I'm Taguhi.</h1>

          <div className='lg:text-xl py-6'>
            <m.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              className='py-2'
            >
              I'm a <strong className='font-900'>front-end developer</strong>{" "}
              based in Belgium, building responsive and user-friendly web
              applications with React, TypeScript, JavaScript, and Tailwind CSS.
            </m.p>

            <m.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
              className='py-2'
            >
              Since completing an intensive full-stack web development program
              at BeCode, I’ve worked on projects for startups, small businesses,
              and established companies, helping build web applications aligned
              with their goals and requirements.
            </m.p>

            <m.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.9 }}
              className='py-2'
            >
              I bring a strong focus on{" "}
              <strong className='font-900'>UI/UX</strong> principles, with
              experience translating design concepts into intuitive and
              accessible interfaces. With a background in Languages and
              Intercultural Communication, I bring strong communication skills
              and a multicultural perspective to international work
              environments.
            </m.p>

            <m.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 1.2 }}
              className='py-2'
            >
              Outside of development, I enjoy music, photography, movies, yoga,
              and cycling, which help me stay creative and inspired.
            </m.p>
          </div>
        </m.div>
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.5 }}
          className='hidden lg:flex lg:w-1/3 items-center justify-center'
        >
          <div className='w-72 lg:w-80 h-80 overflow-hidden rounded-xl flex items-center justify-center'>
            <img
              src={MyPic}
              alt='Profile'
              className='w-full h-full object-cover'
            />
          </div>
        </m.div>
      </div>
    </section>
  );
};

export default About;
